import React, {useState, useContext, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import Modal from '../../../../../Modal/Modal';
import Loader from '../../../../../LoadingIndicator/LoadingIndicator';
import {labels} from '../../../../../../../util/utils';
import Utility from '../../../../../../../util/utilityfunctions';
import styled from 'styled-components';
import {deleteControlAttributes} from '../../../../../../../actions/ControlAttributes/controlattributesaction';
import {getUnresolvedCommentsCount} from '../../../../../../../actions/ValidationControl/validationcontrolactions';
import {DocumentTypeIdContext} from '../../../../../../Main/Forms/CanvasFormContainer';

export default function DeleteControlAttributes(props) {
	const {show, onClose, engagementId, attributeId} = props;
	const dispatch = useDispatch();
	const controlAttributes = useSelector((state) => state.controlAttributes);

	const documentId = Utility.getDocumentIdFromUrl(window);
	const documentTypeId = useContext(DocumentTypeIdContext);

	const [isLoading, setIsLoading] = useState(false);
	const [attributeIndex, setAttributeIndex] = useState(null);

	useEffect(() => {
		if (attributeId) {
			const selectedAttribute = controlAttributes.byId[attributeId];
			if (selectedAttribute) {
				setAttributeIndex(selectedAttribute.attributeIndex);
			}
		}
	}, []);

	const handleDeleteAttribute = async () => {
		setIsLoading(true);
		try {
			onClose();
			await dispatch(deleteControlAttributes(engagementId, attributeId, documentId));
			dispatch(getUnresolvedCommentsCount(engagementId, documentId, documentTypeId));
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<Modal
			show={show}
			onHide={onClose}
			onOkClick={handleDeleteAttribute}
			isOkButtonDisabled={isLoading}
			isCancelButtonDisabled={isLoading}
			disableClose={isLoading}
			showButtons
			title={labels.deleteAttributeButtonLabel}
			closeBtnTitle={labels.modalCancelTitle}
			closeTitle={labels.modalCancelTitle}
			confirmBtnTitle={labels.delete}
			modalsize="x-small"
		>
			{isLoading && (
				<LoaderWrapper>
					<Loader variant="circular" show={isLoading} />
				</LoaderWrapper>
			)}
			<StyledModalBody className="StyledModalBody">
				<Instructions>{labels.deleteControlAttributeInstructions}</Instructions>
				<AttributeIdText>{attributeIndex}</AttributeIdText>
			</StyledModalBody>
		</Modal>
	);
}

DeleteControlAttributes.propTypes = {
	show: PropTypes.bool,
	onClose: PropTypes.func,
	engagementId: PropTypes.number.isRequired,
	attributeId: PropTypes.number.isRequired
};

const StyledModalBody = styled.section``;

const Instructions = styled.section`
	font-size: var(--px-16);
	line-height: var(--px-24);
	margin-bottom: var(--spacing-x-large);
`;

const AttributeIdText = styled.section`
	font-size: var(--px-14);
	font-weight: var(--weight-regular);
	line-height: var(--px-20);
`;

const LoaderWrapper = styled.section`
	position: absolute;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
	top: 0;
	left: 0;

	&::before {
		content: '';
		background-color: var(--white);
		opacity: 0.5;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}
`;
